export const ONLY_OFFICE_API_BASE_URL = "https://tension-participated-bye-engage.trycloudflare.com"
export const FILE_API_BASE_URL = "https://extraordinary-try-harmony-rough.trycloudflare.com";


export type WordFileType =
    | "doc"
    | "docm"
    | "docx"
    | "dot"
    | "dotm"
    | "dotx"
    | "epub"
    | "fb2"
    | "fodt"
    | "hml"
    | "htm"
    | "html"
    | "hwp"
    | "hwpx"
    | "md"
    | "mht"
    | "mhtml"
    | "odt"
    | "ott"
    | "pages"
    | "rtf"
    | "stw"
    | "sxw"
    | "txt"
    | "wps"
    | "wpt"
    | "xml"
export const wordFileTypes: WordFileType[] = [
    "doc",
    "docm",
    "docx",
    "dot",
    "dotm",
    "dotx",
    "epub",
    "fb2",
    "fodt",
    "hml",
    "htm",
    "html",
    "hwp",
    "hwpx",
    "md",
    "mht",
    "mhtml",
    "odt",
    "ott",
    "pages",
    "rtf",
    "stw",
    "sxw",
    "txt",
    "wps",
    "wpt",
    "xml",
];